module.exports = __webpack_public_path__ + "assets/img/4dd4-tr.svg";